import { getUserInfo } from 'utils/api'
import { gtmUserInfoPush } from 'utils/client/analitics'

export default function() {
  getUserInfo().then(response => {
    gtmUserInfoPush(response)
  })
}
